import {
  initBrowserClient,
  TokenType,
  type HttpError,
} from "@gain/common-client/browser";
import {
  browserMasterApi,
  type BrowserMasterApiClient,
} from "@gain/common-client/browser/master";
import { getVariable } from "#shared/config/config.ts";
import type { AuthStore } from "#shared/store/auth-store.tsx";
import { getApiErrorMessage } from "#shared/lib/error-util.ts";

function errorBodyRequestsRedirect(body: string): boolean {
  if (!body.trim()) return false;
  try {
    const parsed = JSON.parse(body) as { redirect?: unknown };
    return Boolean(parsed?.redirect);
  } catch {
    return false;
  }
}

/**
 * `onError` runs after the shared auth handling, so an app can react to
 * statuses only it cares about. All three apps share this client, so anything
 * app-specific belongs there rather than in the handler below.
 */
export function initApi(
  authStore: AuthStore,
  onError?: (error: HttpError) => void,
): void {
  initBrowserClient({
    baseUrl: getVariable("API_ENDPOINT"),
    getToken: (type: TokenType) => {
      return authStore.getToken(type);
    },
    refreshToken: async () => {
      await authStore.refreshToken();
    },
    revision: getVariable("REVISION"),
    onError: (error) => {
      if (error.status === 401 && errorBodyRequestsRedirect(error.body)) {
        authStore.cleanAuth(getApiErrorMessage(error));
      }
      onError?.(error);
    },
  });
}

export const commonApi: BrowserMasterApiClient = browserMasterApi;
